module.exports = __webpack_public_path__ + "img/Skram_Ekteskap_som_tema.f0e8b3d0.jpg";